export const VACATION_STRINGS = {
  INTEGRATION_MESSAGE:
    "Vamos a importar la información necesaria para el módulo de Vacaciones y Permisos desde su sistema base. Esto puede tardar algunos segundos.",
  INTEGRATION_CONFIRM_BUTTON_LABEL: "Continuar",
} as const;
